import gql from 'graphql-tag'

export const DEFAULT_TAG_VALUES = {
    name: '',
}

export const fragments = {
  tag: gql`
    fragment tagFields on Tag {
      id
      name
      bookmarksCount

      updatedAt
      createdAt
    }
  `
}

export const GET_UNTAGGED_QUERY = gql`
  query Untagged {
      untagged {
      ...tagFields
    }
  }
  ${fragments.tag}
`

export const GET_ALL_TAGS_QUERY = gql`
  query tags($page: Int, $limit: Int) {
    tags(page: $page, limit: $limit) {
      collection {
        ...tagFields
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
  ${fragments.tag}
`

export const GET_ALL_TAGS_NO_PAGE_QUERY = gql`
  query tags($limit: Int) {
    tags(limit: $limit) {
      collection {
        ...tagFields
      }
    }
  }
  ${fragments.tag}
`

export const GET_TAG_QUERY = gql`
  query tags($id: Int!) {
    tag(id: $id) {
      ...tagFields
    }
  }
  ${fragments.tag}
`

export const CREATE_TAG_MUTATION = gql`
  mutation createTag($tag: TagInput!) {
    tags: createTag(tag: $tag) {
      ...tagFields
    }
  }
  ${fragments.tag}
`

export const UPDATE_TAG_MUTATION = gql`
  mutation updateTag($id: Int!, $tag: TagInput!) {
    tags: updateTag(id: $id, tag: $tag) {
      ...tagFields
    }
  }
  ${fragments.tag}
`

export const DELETE_TAG_MUTATION = gql`
  mutation deleteTag($name: String!, $cascadeType: String!) {
    tags: deleteTag(name: $name, cascadeType: $cascadeType) {
      ...tagFields
    }
  }
  ${fragments.tag}
`

export const RENAME_TAG_MUTATION = gql`
  mutation renameTag($from: String!, $to: String!) {
    tags: renameTag(from: $from, to: $to) {
      ...tagFields
    }
  }
  ${fragments.tag}
`
